import React from "react"
import VideoPage from "../components/video-page"

const Tentakulum5Page = () => (
  <VideoPage title="TENTAKULUM 5" path="/video/tentakulum-5.{ext}" />
)

export default Tentakulum5Page
